module.exports = __webpack_public_path__ + "img/rainbow_flag.df414729.gif";